// redirect.js
export const redirectToAuth = () => {
    window.location.href = '/auth'; // Force a full redirect to the auth page
};
